import * as React from 'react';
import DCSingleLevelContainer from "../DCSingleLevelContainer/index";
import SimPlayer from "../../fbobjects/calculation/SimPlayer";
import GoogleSheetDB from "../../fbobjects/GoogleSheetDB";
import Player from "../../fbobjects/Player";
import {createSimPlayer} from "../../fbobjects/calculation/Calculation";
import _ = require("lodash");
import './dccontainer.css'
import {ComboInfo} from "../../fbobjects/ComboInfo";
import {SimSkillOrder} from "../../fbobjects/calculation/SkillOrder";

interface DCContainerProps {
    source:Player;
    target:Player;
}

export default class DCContainer extends React.Component<DCContainerProps,any> {

    props:DCContainerProps;

    constructor(props:DCContainerProps){
        super(props);
        this.props = props;
    }

    isRelevantCombo(combo:ComboInfo, playerLevelInput:number):boolean{
        let playerLevel = playerLevelInput;
        let rawRelevantLevels = combo.levelRelevance;
        let commaRelevantLevels = rawRelevantLevels.split(' ').join('').split(",");

        for (let i = 0; i < commaRelevantLevels.length; i++){
            let relevantLevel = commaRelevantLevels[i];
            if (relevantLevel.indexOf('-') != -1){
                let splitItem = relevantLevel.split('-');
                if (playerLevel >= parseInt(splitItem[0]) && playerLevel <= parseInt(splitItem[1])){
                    return true;
                }
            }
            if (parseInt(relevantLevel) == playerLevel){
                return true;
            }
        }
        return false;
    }

    renderAllLevels():any{
        let levels = [];
        let curChamp = this.props.source.selectedChampion;
        let combos = GoogleSheetDB.getChampionCombos(curChamp);
        let combosToRender;

        if (combos == undefined){
            return <div className="no-combos-display">This is embarassing... We don't currently have combos for this champion. Sorry!</div>
        }

        for (let i = 0; i < 12; i++) {
            let level = i+1;
            combosToRender = combos.filter((item)=>this.isRelevantCombo(item, level));
            if (combosToRender.length != 0){
                levels.push(<DCSingleLevelContainer source={this.props.source} target={this.props.target} key={i} level={level} combos={combosToRender}/>)
            }
        }

        return levels;
    }


    render(){
        return(
            <div className="damage-chart-container">
                {this.renderAllLevels()}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/DCContainer/index.tsx